export default {"src":"/newStatic/_next/static/media/boxes-2.7080aefb.svg","height":90,"width":53};